import React from 'react';

// Inlined directly as JSX (not imported as a .svg asset) — `frontend/`'s Vite config treats
// .svg imports as SVGR components while this package's own build treats them as URL strings,
// and that mismatch previously broke browser-tests-frontend CI across unrelated test files.
export const HeaderMarkIcon = () => (
  <svg fill="none" height="24" viewBox="0 0 80 80" width="24">
    <g stroke="#1A202C" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.96}>
      <rect
        height={39.88}
        rx={3.68}
        ry={3.68}
        transform="translate(-16.57 40) rotate(-45)"
        width={39.88}
        x={20.06}
        y={20.06}
      />
      <line x1={13.32} x2={65.6} y1={40} y2={40} />
      <line x1={40} x2={27.99} y1={13.32} y2={40} />
      <line x1={40} x2={52.01} y1={13.32} y2={40} />
      <line x1={40} x2={52.01} y1={66.35} y2={39.67} />
      <line x1={40} x2={27.99} y1={66.35} y2={39.67} />
    </g>
  </svg>
);
